import { Type } from '@sinclair/typebox';
const state = Type.Object({ name: Type.String(), code: Type.String() });
export const countrySchema = Type.Object({
    code: Type.String(),
    name: Type.String(),
    states: Type.Optional(Type.Record(Type.String(), state)),
});
export const shippingCountrySchema = Type.Intersect([
    countrySchema,
    Type.Object({
        currency: Type.String(),
        active: Type.Boolean(),
    }),
]);
export const countriesResponseSchema = Type.Object({
    shippingCountries: Type.Array(shippingCountrySchema),
    allCountries: Type.Array(countrySchema),
});
//# sourceMappingURL=shipping.js.map